export default __webpack_public_path__ + "static/media/Onepicture.74858e18.jpg";